import accordion from '../components/accordion';
import {initProductTile} from '../productTileComponent/productTile';
import initRefineBarComponent from './refineBarComponent';

export {
    ajaxCall_changeRefinements,
    ajaxCall_changeExternalRefinements,
    ajaxCall_clickSortOption,
    ajaxCall_changeGridView,
};

function genericAjaxCall(url, pushState = true) {
    if (!url) {
        console.error('Missing Url in ajax call');
        return;
    }
    $.spinner().start();
    return new Promise((resolve, reject) => {
        $.ajax({
            url: url,
            data: {
                selectedUrl: url,
                page: 0,
            },
            method: 'GET',
            success: function (response) {
                if (pushState) {
                    history.pushState({}, '', url);
                }
                $.spinner().stop();
                resolve($(response).clone());
            },
            error: function (error) {
                $.spinner().stop();
                console.error(error);
                reject(error);
            },
        });
    });
}

function ajaxCall_changeRefinements(url) {
    var $activeElement = $(document.activeElement);
    var activeUrl = $activeElement.data('url') || null;
    var activeValueId = $activeElement.data('value-id') || null;

    genericAjaxCall(url).then(function (newDom) {
        var addictionalElementArray = [
            '.js-plp-refineBar-externalRefinement',
            '.js-plp-refineBar-sortOptions',
        ];
        simpleElementToReplace(newDom, addictionalElementArray);
        refinementsAccordionToReplace(newDom);
        productTilesReplace(newDom);
        restoreRefinementFocus(activeUrl, activeValueId);
    });
}

function restoreRefinementFocus(activeUrl, activeValueId) {
    var $target = null;

    if (activeValueId) {
        $target = $('[data-value-id="' + activeValueId + '"]').filter('.js-changeRefinementValue_button, .js-changeRefinementValue_input').first();
    }
    if ((!$target || !$target.length) && activeUrl) {
        $target = $('[data-url="' + activeUrl + '"]').filter('.js-changeRefinementValue_button, .js-changeRefinementValue_input').first();
    }
    if ($target && $target.length) {
        $target[0].focus({ preventScroll: true });
    }
}

function ajaxCall_changeExternalRefinements(url) {
    return new Promise((resolve) => {
        genericAjaxCall(url)
            .then(function (newDom) {
                var addictionalElementArray = ['.js-plp-refineBar-sortOptions'];
                simpleElementToReplace(newDom, addictionalElementArray);
                refinementsAccordionToReplace(newDom);
                productTilesReplace(newDom);
                updateExternalRefinement(newDom);
                resolve(true);
                refinementsApplied();
            })
            .catch(function () {
                resolve(false);
            });
    });
}

function ajaxCall_clickSortOption(url) {
    return new Promise((resolve) => {
        genericAjaxCall(url)
            .then(function (newDom) {
                var addictionalElementArray = [
                    '.js-plp-refineBar-externalRefinement',
                    '.js-cc-wrapper-refineBar-sort-options',
                ];
                simpleElementToReplace(newDom, addictionalElementArray);
                refinementsAccordionToReplace(newDom);
                productTilesReplace(newDom);
                $('.js-plp-refineBar-buttonMenu').removeClass('cc-plp-refineBar-button_open');

                initRefineBarComponent();
                resolve(true);
                sortingRulesApplied();
            })
            .catch(function () {
                resolve(false);
            });
    });
}

function ajaxCall_changeGridView(url) {
    genericAjaxCall(url).then(function (newDom) {
        var addictionalElementArray = [
            '.js-plp-refineBar-externalRefinement',
            '.js-plp-refineBar-sortOptions',
        ];
        simpleElementToReplace(newDom, addictionalElementArray);
        refinementsAccordionToReplace(newDom);
        productTilesReplace(newDom);
    });
}

// FUNCTION TO REPLACE-UPDATE DOM
function simpleElementToReplace(newDom, addictionalArrayToCleanUp) {
    var elementToCleanUp = [
        '.js-plp-refinements-footer',
        '.js-plp-refineBar-refinementsCount',
        '.js-plp-refineBar-externalRefinementsCount',
        '.js-plp-specialRef-container',
        '.js-plp-pagination',
    ];

    var elementToReplace = ['.js-plp-refineBar-gridToggle'];

    if (addictionalArrayToCleanUp) {
        elementToCleanUp = elementToCleanUp.concat(addictionalArrayToCleanUp);
    }
    elementToCleanUp.forEach((elem) => {
        var $newBlock = newDom.find(elem).first();
        var $oldBlock = $(elem).first();
        if ($newBlock.length && $oldBlock.length) {
            $oldBlock.replaceWith($newBlock);
        }
    });

    elementToReplace.forEach((elem) => {
        var $newBlock = newDom.find(elem).first();
        var $oldBlock = $(elem).first();
        if ($newBlock.length && $oldBlock.length) {
            $oldBlock.replaceWith($newBlock);
        }
    });
}

function refinementsAccordionToReplace(newDom) {
    const refinementBody = '.js-plp-refinements-body';
    const refinementBodyAccordion = '.js-plp-refinements-accordion';
    const dataRefActive = $('.js-plp-refinements-body-accordionItem.active').data('refinement');

    var newRefinementBody = newDom.find(refinementBody);
    var newAccordion = newRefinementBody.find(refinementBodyAccordion);

    accordion.setup(newAccordion);

    if (dataRefActive) {
        var activeAccordion = newAccordion.find(
            `.js-plp-refinements-body-accordionItem[data-refinement=${dataRefActive}]`
        );
        activeAccordion.addClass('active').find('.accordion-content').css('display', 'block');
    }

    $(refinementBody).replaceWith(newRefinementBody);
}

function productTilesReplace(newDom) {
    const PRODUCT_GRID = '.js-plp-productGrid';
    const CLASS_OPEN = 'cc-plp-productGrid_open';
    const newProductTile = newDom.find(PRODUCT_GRID);

    if (newProductTile.length > 0) {
        var oldGrid = $(PRODUCT_GRID);
        if (oldGrid.hasClass(CLASS_OPEN)) {
            newProductTile.addClass(CLASS_OPEN);
        }
        oldGrid.replaceWith(newProductTile);
        initProductTile();
        refinementsApplied();
    } else {
        console.error('Error in product tile update');
    }
}

function updateExternalRefinement(newDom) {
    const elementToReplace = '.js-plp-refineBar-menu-body_externalRefinement';
    var newBlock = newDom.find(elementToReplace);
    if (newBlock) {
        $(elementToReplace).replaceWith(newBlock);
    }
}

// Analytics plp listing events update
function refinementsApplied () {
    let openRefinementIDs = [];
    $('.analytics-search-filter').toArray().forEach(refinement => {
        if ($(refinement).hasClass('cc-plp-refinement-size-button_selected')) {
            openRefinementIDs.push($(refinement).data('value-id'));
        }
    });
    $('.analytics-search-filter-boolean').toArray().forEach(refinement => {
        if ($(refinement).is(':checked')) {
            openRefinementIDs.push($(refinement).data('analytics-name'));
        }
    });
    updateListingForAnalytics(openRefinementIDs.length ? 'filter_applied' : 'listing');
}

function sortingRulesApplied () {
    let sortingRule = $('.cc-plp-refineBar-menu_sort_active').data('analytics-sorting-rule').replaceAll('-','_');
    updateListingForAnalytics(sortingRule);
}

function updateListingForAnalytics (listType) {
    const analyticsItems = [];
    $('.analytics-search-results .js-prodTile')
        .find('.analytics.productListingItem')
        .each(function () {
            analyticsItems.push($(this).data());
        });
    $('body').trigger('listing:filter_or_sort_applied', {
        dataArray: analyticsItems,
        listType: listType,
    });
}
